import styled from 'styled-components'
import { Row, Col, Card } from 'react-bootstrap'
import { ContainerFrame, FooterSection, ArticleSuggest } from '@components'
import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { InspirationAPI, InspirationDetailAPI } from '@api'
import { useTranslation } from 'react-i18next'

const Container = styled.div`
  padding-top: 56px;
  overflow: hidden;
`

const Title = styled.div`
  font-size: 1.8em;
  color: #85714d;
  font-weight: bold;
`

const Subtitle = styled.div`
  color: #8a8d8f;
`

const Link = styled.span`
  color: #f2a900;
`

const ArticleBox = styled.div`
  display: grid;
  row-gap: 14px;
`

const Img = styled.img`
  width: 100%;
  height: 450px;
  object-fit: cover;
  margin: 0px auto;
  @media (max-width: 768px) {
    height: 300px;
  }
`

const CapImage = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #8a8d8f;
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const ListInspirationDetail = function () {
  const { t } = useTranslation()
  let { slug } = useParams()
  const [article, setArticle] = useState(null)
  const [listArticle, setListArticle] = useState([])

  useEffect(async () => {
    const { data } = await InspirationDetailAPI(slug)
    setArticle(data?.data || null)
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (article != null) {
      const { data } = await InspirationAPI(``)
      let count = 0
      const tmp = []
      data.data.item.map((item, index) => {
        if (slug === item.slug || count > 4) return true
        count = count + 1

        if (item.deskripsi != null) {
          tmp.push(
            <ArticleSuggest
              key={index}
              title={item.judul}
              subtitle={item.deskripsi.replace(/(<([^>]+)>)/gi, '')}
              slug={item.slug}
              type="inspirasi"
            />
          )
        } else {
          tmp.push(
            <ArticleSuggest
              key={index}
              title={item.judul}
              slug={item.slug}
              type="inspirasi"
            />
          )
        }
      })

      setListArticle(tmp)
    }
  }, [article])

  return (
    <Container>
      <ContainerFrame className="text-start py-5">
        {article != null && (
          <Row>
            <Col xs={12} md={9}>
              <div>
                <Title>{article.judul}</Title>
                <Subtitle>
                  {t('oleh')} <Link>{article.oleh}</Link> {t('di')}{' '}
                  <Link>{article.tempat}</Link>
                </Subtitle>

                <Desktop>
                  <Img className="mb-4 mt-2" src={article.imageDesktop} />
                </Desktop>
                <Mobile>
                  <Img className="mb-4 mt-2" src={article.imageMobile} />
                </Mobile>
                <CapImage
                  dangerouslySetInnerHTML={{ __html: article.captionImage }}
                />
                <div
                  className="mt-4"
                  dangerouslySetInnerHTML={{ __html: article.deskripsi }}
                />
              </div>
            </Col>
            <Col xs={12} md={3} className="pt-4">
              {Object.keys(listArticle).length > 0 && (
                <Card className="p-3" style={{ background: 'transparent' }}>
                  <div>
                    <div className="col-12 mb-2 d-flex justify-content-start align-items-center">
                      <div className="fw-bold color-brown">
                        {t('inspirasi_lainnya')}
                      </div>
                    </div>
                    <ArticleBox>{listArticle}</ArticleBox>
                  </div>
                </Card>
              )}
            </Col>
          </Row>
        )}
      </ContainerFrame>

      <FooterSection currentPage={t('inspirasi_detail')} />
    </Container>
  )
}

export default ListInspirationDetail
